import { SectionShell, Field } from "./SectionShell";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { RadioGroup, RadioGroupItem } from "../ui/radio-group";
import { FREQ, AFFECTS, inputCls } from "./constants";

export default function PainsTab({ data, update, onVoice }) {
  const updatePain = (idx, key, val) => {
    const pp = [...data.pain_points];
    pp[idx] = { ...pp[idx], [key]: val };
    update({ pain_points: pp });
  };

  return (
    <SectionShell eyebrow="Section 2 · 12 min" title="Pain Point Discovery" voiceSection="pain_points" onVoice={onVoice}>
      <p className="text-sm text-navy/60 mb-6 -mt-4">Capture up to 4 pain points. Probe for specifics: hours lost, who it affects, workarounds.</p>
      <div className="space-y-8">
        {(data.pain_points || []).map((p, idx) => (
          <div key={idx} className="border-l-2 border-gold pl-6">
            <div className="eyebrow text-navy/50 mb-3">Pain Point {idx + 1}</div>
            <div className="grid md:grid-cols-2 gap-5">
              <div className="md:col-span-2">
                <Field label="Description (in their words)">
                  <Textarea data-testid={`pain-desc-${idx}`} className={inputCls} rows={2} value={p.description || ""} onChange={(e) => updatePain(idx, "description", e.target.value)} />
                </Field>
              </div>
              <Field label="Frequency">
                <RadioGroup value={p.frequency || ""} onValueChange={(v) => updatePain(idx, "frequency", v)} className="flex flex-wrap gap-4">
                  {FREQ.map((f) => (
                    <label key={f} className="flex items-center gap-2 text-sm text-navy">
                      <RadioGroupItem value={f} id={`pf-${idx}-${f}`} data-testid={`pain-freq-${idx}-${f}`} /> {f}
                    </label>
                  ))}
                </RadioGroup>
              </Field>
              <Field label="Est. Hours Lost / Week">
                <Input type="number" data-testid={`pain-hours-${idx}`} className={inputCls} value={p.hours_lost_per_week || 0}
                  onChange={(e) => updatePain(idx, "hours_lost_per_week", parseFloat(e.target.value) || 0)} />
              </Field>
              <Field label="Who It Affects">
                <RadioGroup value={p.who_it_affects || ""} onValueChange={(v) => updatePain(idx, "who_it_affects", v)} className="flex flex-wrap gap-4">
                  {AFFECTS.map((a) => (
                    <label key={a} className="flex items-center gap-2 text-sm text-navy">
                      <RadioGroupItem value={a} id={`pa-${idx}-${a}`} data-testid={`pain-affects-${idx}-${a}`} /> {a}
                    </label>
                  ))}
                </RadioGroup>
              </Field>
              <Field label="Current Workaround">
                <Input data-testid={`pain-workaround-${idx}`} className={inputCls} value={p.current_workaround || ""} onChange={(e) => updatePain(idx, "current_workaround", e.target.value)} />
              </Field>
            </div>
          </div>
        ))}
      </div>
    </SectionShell>
  );
}
